import { Typography, Image, Row } from "antd";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import clanakService from "../../services/clanak.service";
import { Skeleton, Col, Space } from "antd";
import FormattedContent from "./FormattedClanak";
import { UserOutlined } from "@ant-design/icons";
import "./ViewClanak.css";
import { formatDateTime } from "../../utils/formatDateTime";
import Background from "../../components/Background4";
import ReactCrop, { centerCrop, makeAspectCrop } from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import GalerijaSlikaClanka from "./GalerijaSlikaClanka";
import NotFound from "../../components/NotFound";

  
const { Title } = Typography;
const { Text } = Typography;

const ViewClanak = () => {
  const { id } = useParams();
  const [clanak, setClanak] = useState(null);
  const [galerija, setGalerija] = useState([]);
  const [crop, setCrop] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    const fetchClanak = async () => {
      try {
        const [clanakRes, galerijaRes] = await Promise.all([
          clanakService.getById(id),
          clanakService.getGalerija(id),
        ]);
        setClanak(clanakRes.data);
        setGalerija(galerijaRes.data);
      } catch (error) {

         if (error.response && error.response.status === 404) {
          setNotFound(true);
        } else {
          console.error("Greška pri učitavanju ankete:", error);
        }
      }
    };

    fetchClanak();
  }, [id]);

/* useEffect(() => {
    const fetchClanak = async () => {
      try {
        const response = await clanakService.getById(id);
        setClanak(response.data);
      } catch (error) {}
    };

    fetchClanak();
  }, [id]);*/

  const onImageLoad = (e) => {
    const { width, height } = e.currentTarget;
    const crop = centerCrop(
      makeAspectCrop(
        {
          unit: "%",
          width: 90,
        },
        16 / 9,
        width,
        height
      ),
      width,
      height
    );
    setCrop(crop);
  };

  const handleCropComplete = (crop) => {
    setCrop(crop);
  };

  const toggleCrop = (imageType, imageId = null) => {
    if (imageType === "main") {
      setSelectedImage(selectedImage ? null : clanak.slika);
    } else {
      const selectedGalleryImage = galerija.find((img) => img.id === imageId);
      setSelectedImage(
        selectedImage
          ? null
          : selectedGalleryImage
          ? selectedGalleryImage.putanja
          : null
      );
    }
  };
 if (notFound) return <NotFound />;
  if (!clanak) return <Skeleton />;

  return (
    <div className="view-clanak-bijeli">
      <Background />
      <div className="view-clanak-container">
        <div className="clanak-content">
          <Row>
            <Col span={24} align={"middle"}>
              <Title>{clanak.naslov}</Title>
            </Col>
          </Row>
          {clanak.slika && (
            <Row style={{ marginBottom: "1rem" }}>
              <Col span={24} align="middle">
                {selectedImage === "main" ? (
                  <ReactCrop
                    crop={crop}
                    onChange={(_, percentCrop) => setCrop(percentCrop)}
                    onComplete={handleCropComplete}
                    aspect={16 / 9}
                    style={{ maxWidth: "100%", width: "100%" }}
                  >
                    <Image
                      src={clanak.slika}
                      alt="Glavna slika"
                      onLoad={onImageLoad}
                      style={{
                        width: "100%",
                        aspectRatio: "16/9",
                        objectFit: "cover",
                      }}
                      fallback="https://via.placeholder.com/600x400?text=Slika+nije+dostupna"
                      imgProps={{ style: { objectFit: "cover" } }}
                    />
                  </ReactCrop>
                ) : (
                  <Image
                    src={clanak.slika}
                    alt="Glavna slika"
                    onClick={() => toggleCrop("main")}
                    style={{
                      width: "100%",
                      objectFit: "cover",
                      aspectRatio: "16/9",
                    }}
                    fallback="https://via.placeholder.com/600x400?text=Slika+nije+dostupna"
                  />
                )}
              </Col>
            </Row>
          )}

          <Row className="clanak-info-row" align={"middle"}>
            <Col span={8}>
              <Space>
                <Text type="secondary">
                  <UserOutlined />
                </Text>
                <Text type="secondary">{clanak.autor}</Text>
              </Space>
            </Col>

            <Col span={8} offset={8}>
              <Text type="secondary">{formatDateTime(clanak.datumObjave)}</Text>
            </Col>
          </Row>

          <Row className="clanak-sadrzaj-row">
            <Col span={24} /*align={"middle"}*/>
              <FormattedContent content={clanak.sadrzaj} />
            </Col>
          </Row>

          <Row>
            <Col span={24} align={"middle"}>
              <GalerijaSlikaClanka galerija={galerija} />
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default ViewClanak;
